import { render, staticRenderFns } from "./DomainVerifications.vue?vue&type=template&id=721ff74f&scoped=true&lang=pug&"
import script from "./DomainVerifications.vue?vue&type=script&lang=js&"
export * from "./DomainVerifications.vue?vue&type=script&lang=js&"
import style0 from "./DomainVerifications.vue?vue&type=style&index=0&id=721ff74f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ff74f",
  null
  
)

/* custom blocks */
import block0 from "./DomainVerifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDivider,VLayout,VProgressCircular,VRow,VSpacer,VTextField})
